import cn from 'classnames';
import type { To } from 'react-router';
import { Link } from '#components/atoms/link/Link.tsx';
import { useAppLocation } from '#hooks/useAppLocation.ts';
import styles from './NameCell.module.css';

type Props = {
  name: string;
  nameTo: To;
  /** Shown after name */
  children?: React.ReactNode;
  secondRow?: React.ReactNode;
};

export function NameCell({ name, nameTo, children, secondRow }: Props) {
  const location = useAppLocation();

  return (
    <div className="flex flex-col justify-center" style={{ overflow: 'hidden' }}>
      <div className="flex">
        <Link className={cn('a inline truncate', styles.NameCell_link)} to={nameTo} state={{ from: location }}>
          {name}
        </Link>
        {children}
      </div>
      {secondRow ?
        <div className="p-sm mb-0 display-contents">{secondRow}</div>
      : null}
    </div>
  );
}
